import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, tap } from 'rxjs';
import { OpenIdService } from '../services/open-id.service';

export const userAuthGuard: CanActivateFn = (route, state) => {
  if (typeof window === 'undefined') {
    return false;
  }
  const oidc = inject(OidcSecurityService);
  const openId = inject(OpenIdService);

  return oidc.isAuthenticated$.pipe(
    tap((result) => {
      if (!result.isAuthenticated) {
        openId.login(undefined, state?.url);
      }
    }),
    map((result) => result.isAuthenticated),
  );
};
